<template>
  <div class="logo-bg" v-loading="loading">
    <div class="login-cont">
      <div class="login-cont-left">
        <img alt="" class="login-logo" src="@/assets/img/login/logo.png">
        <div class="login-des">专注儿童畸形矫正方案定制</div>
        <div class="login-intro">
          <div class="login-intro-line">
            <div class="login-intro-line-top">
              <img alt="" src="@/assets/img/login/icon1.png">
              <div class="black-14">在线指导</div>
            </div>
            <div class="login-intro-line-other">导师一对一案例咨询，一教就会</div>
          </div>
          <div class="login-intro-line">
            <div class="login-intro-line-top">
              <img alt="" src="@/assets/img/login/icon2.png">
              <div class="black-14">及时批注</div>
            </div>
            <div class="login-intro-line-other">在线协助，精准绘图，沟通变得如此简单</div>
          </div>
          <div class="login-intro-line">
            <div class="login-intro-line-top">
              <img alt="" src="@/assets/img/login/icon3.png">
              <div class="black-14">病例管理</div>
            </div>
            <div class="login-intro-line-other">病例终身管理，可查可画可归档</div>
          </div>
        </div>
      </div>
      <div class="login-cont-right">
        <div class="login-nav">
          <div :class="loginType ? 'on' : ''" @click="loginType=true">验证码登录</div>
          <div :class="loginType ? '' : 'on'" @click="loginType=false">密码登录</div>
        </div>
        <div v-if="loginType" class="login-tip">未注册的手机号验证成功将自动注册</div>
        <div class="input-line mt-32" :data-attr="toastInfo.telephone">
          <input v-model="telephone" placeholder="请输入手机号" type="text" @input="inputChange($event,'telephone')">
        </div>
        <div v-if="loginType" class="input-line" :data-attr="toastInfo.code">
          <input v-model="code" placeholder="请输入验证码" type="text" @input="inputChange($event,'code')">
          <div :class="checkTelephone && sendCode ? '' : 'dis-bg'" class="input-code-btn black-14" @click.stop="getCode">
            {{ sendText }}
          </div>
        </div>
        <div v-if="!loginType" class="input-line" :data-attr="toastInfo.password">
          <input v-model="password" placeholder="请输入密码" type="password" @input="inputChange($event,'password')">
        </div>
        <div v-if="!loginType" class="black-14 forget-btn" @click="goTo('/reset')">忘记密码？</div>
        <div class="submit-btn black-14" @click="submitForm" :class="isRight ? '' : 'dis-bg'">登录{{ loginType ? '/注册' : '' }}</div>
        <div class="login-read" @click="isAgree = !isAgree">
          <div :class="isAgree ? 'login-read-ok' : ''" class="iconfont icon-dangou login-read-radio"></div>
          <div class="login-read-info">我已阅读并同意<span @click.stop="openDialog('user')">用户协议</span>和<span @click.stop="openDialog('privacy')">隐私协议</span></div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showDialog" custom-class="take-dialog" :title="showDialogType == 'user' ? '用户协议' : '隐私政策'" width="834px">
      <div class="protocol" v-html="dialogInfo[showDialogType]"></div>
    </el-dialog>
  </div>
</template>

<script>
import { Login, LoginByPassword } from "@/http/api";
import { user_info, getListByTypeCode } from "@/http/user_center";
import { sendSmsCode } from "@/http/login";

export default {
  name: "index",
  data() {
    return {
      loginType: true, //true验证码登录，false密码登录
      telephone: "",
      code: "",
      password: "",
      isAgree: false,
      toastInfo: {
        telephone: "",
        password: "",
        code: "",
      },
      isRight: false,
      showDialog: false,
      showDialogType: "",
      dialogInfo: {
        user: "",
        privacy: "",
      },
      checkTelephone: false,
      checkCode: false,
      checkPassword: false,
      loading:false,
      sendCode:true,
      sendText:'获取验证码'
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (localStorage.getItem("token") && localStorage.getItem("member")) {
        user_info().then((res) => {
          if (res.code == 200) {
            if (res.data.is_perfect == 0) {
              // if (from.path !== "/sign") {
                vm.$router.push("/sign");
              // }
            } else {
              vm.$router.push("/home");
            }
          }
        });
      }
    });
  },
  created() {
    this.getAgreement();
  },
  methods: {
    goTo(url){
      this.$router.push(url)
    },
    submitForm() {
      if (!this.isAgree) {
        this.$message({
          type: "info",
          message: "请先阅读并同意用户协议和隐私协议",
        });
        return false;
      }
      this.loading = true
      if (this.loginType) {
        Login({
          telephone: this.telephone,
          code: this.code,
          from: "pc",
        }).then((res) => {
          this.loading = false
          if (res.code == 200) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("member", JSON.stringify(res.data.member));
            this.$store.commit("memberChange", res.data.member);
            if (res.data.toPerfectInfo) this.$router.push("/sign");
            else this.$router.push("/home");
          } else {
            this.$message.error(res.message[0]);
          }
        });
      } else {
        LoginByPassword({
          telephone: this.telephone,
          password: this.password,
          from: "pc",
        }).then((res) => {
          this.loading = false
          if (res.code == 200) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("member", JSON.stringify(res.data.member));
            this.$store.commit("memberChange", res.data.member);
            if (res.data.toPerfectInfo) this.$router.push("/sign");
            else this.$router.push("/home");
          } else {
            this.$message.error(res.message[0]);
          }
        });
      }
    },
    getCode() {
      if (this.isRight && this.sendCode) {
        return;
      }
      let _that = this
      this.sendCode = false
      sendSmsCode({ telephone: this.telephone }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "发送成功",
          });
          let countDown = 60
          let sendTimer = setInterval(()=>{
            countDown -= 1
            if(countDown > 0){
              _that.sendText = countDown + 's'
            }else{
              _that.sendText = '获取验证码'
              _that.sendCode = true
              clearInterval(sendTimer)
            }
          },1000)

        } else {
          _that.sendCode = true
          this.$message.error(res.message[0] ? res.message[0] : "发送失败");
        }
      });
    },
    inputChange(e, type) {
      if (type == "code") {
        if (this.code.length == 4) {
          this.toastInfo.code = "";
          this.checkCode = true;
        } else {
          this.toastInfo.code = "请输入4位验证码";
          this.checkCode = false;
        }
      } else if (type == "password") {
        if (this.password.trim() != "") {
          this.toastInfo.password = "";
          this.checkPassword = true;
        } else {
          this.toastInfo.password = "请输入密码";
          this.checkPassword = false;
        }
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.telephone)) {
          this.toastInfo.telephone = "请输入正确的手机号";
          this.checkTelephone = false;
        } else {
          this.toastInfo.telephone = "";
          this.checkTelephone = true;
        }
      }
      if (this.loginType && this.checkTelephone && this.checkCode)
        this.isRight = true;
      else if (!this.loginType && this.checkTelephone && this.checkPassword)
        this.isRight = true;
      else this.isRight = false;
    },
    openDialog(type) {
      this.showDialog = true;
      this.showDialogType = type;
    },
    getAgreement() {
      getListByTypeCode({ type_code: ["yinsizhengce", "yonghuxieyi"] }).then(
        (res) => {
          if (res.code == 200) {
            this.dialogInfo.privacy = res.data.yinsizhengce;
            this.dialogInfo.user = res.data.yonghuxieyi;
          }
        }
      );
    },
  },
};
</script>

<style scoped src="../../assets/css/login.css"></style>
<style>
.input-line::after {
  content: attr(data-attr);
  color: #fed400;
  font-size: 12px;
  position: relative;
  top: -5px;
}
</style>
